var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDone,
      expression: "!isDone"
    }]
  }, [_vm._t("on-going")], 2)]), _c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isDone,
      expression: "isDone"
    }]
  }, [_vm._t("finished")], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }